import { Component, OnInit, SimpleChanges, Input, ElementRef } from '@angular/core';
import { QnASearchService } from '../Services/qna-search.service';
import { QnASearchResultViewModel, QuestionAndAnswer, TocTabPageQnAViewAllBlockModel } from '../Models/common.model';
import { paginate } from '../Models/common.pagination';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as Global from "../Models/constants";

declare var ReadStaticData;
let response: string;

@Component({
    selector: 'toctabpage-qna-viewall',
    templateUrl: './toctabpage-qna-viewall.component.html',
    providers: [QnASearchService]
})
export class TocTabPageQnAViewAllComponent implements OnInit {
    @Input() public loadingMessage: string;

    page = 1;
    pageSize = 10;
    maxPages = 10;
    currentPageId: number;
    startIndex: number;
    endIndex: number;
    pager: any = {};
    isLoading: boolean = true;
    searchQuery: string = null;
    filter: string = null;
    searchTag: string;
    isTextSearch: boolean = false;
    statuses: string[] = [Global.statusAnswered];
    tocTabPageQnAViewAllBlockModel: TocTabPageQnAViewAllBlockModel;
    private _searchText: string;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
    }

    private _searchResults: QnASearchResultViewModel<QuestionAndAnswer>;
    get searchResults(): QnASearchResultViewModel<QuestionAndAnswer> {
        return this._searchResults;
    }
    set searchResults(value: QnASearchResultViewModel<QuestionAndAnswer>) {
        this._searchResults = value;
    }
    constructor(public dataService: QnASearchService, private modalService: NgbModal, private element: ElementRef) {
        
    }

    ngOnInit(): void {
        this.getStaticData();
        this.peformSearch();
        this.loadingMessage = "Please wait while data is loading.."
    }

    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {
            this.onChangePage(this.page);
        }
    }

    peformSearch(): void  {
        this.dataService.getSearchResults(this.currentPageId, this.page, this.pageSize, this.searchText, this.filter, this.statuses, this.tocTabPageQnAViewAllBlockModel.GetQnAFor).subscribe((data: QnASearchResultViewModel<QuestionAndAnswer>) => {
            this.searchResults = data;
            this.searchResults.NoResultMessage = this.tocTabPageQnAViewAllBlockModel.NoResultText;
            this.setPage(this.searchResults);
            this.isLoading = false;
            window.location.href = "#topofbody";
        })
    }

    getStaticData(): void {
        response = ReadStaticData();
        this.tocTabPageQnAViewAllBlockModel = JSON.parse(response);
        this.pageSize = this.tocTabPageQnAViewAllBlockModel.PageSize;
        this.currentPageId = this.tocTabPageQnAViewAllBlockModel.CurrentPageId;
    }

    performTextSearch(event) {
        this.isLoading = true;
        this.page = 1;

        if (this.searchText != null || this.searchText != undefined) {
            this.searchQuery = this.searchText;
            this.peformSearch();
        }
    }

    onChangePage(pageIndex: any) {
        this.page = pageIndex;
        this.peformSearch();
    }

    onFilterClick(event, text:any, value: any) {
        document.getElementById("dropdownMenuLink").innerText = "Filter: " + text;
        this.filter = value;
        this.page = 1;
        this.isLoading = true;
        this.peformSearch();
    }

    setPage(searchResults: QnASearchResultViewModel<QuestionAndAnswer>) {
        this.pager = paginate(searchResults.TotalMatching, this.page, this.pageSize, this.maxPages);

        //set nnumber of items per pages.
        this.startIndex = this.pager.startIndex + 1;
        this.endIndex = this.pager.endIndex + 1;
    }

    onSearchClick(event) {
        this.element.nativeElement.querySelector('#swapa-qna-search-dropdown').setAttribute('class', 'flex-direction-column d-md-none py-2 d-flex');
        this.element.nativeElement.querySelector('#swapa-qna-search-button').setAttribute('class', 'btn btn-link btn-sm d-none d-md-none swapa-search bg-white rounded-0');
    }

    closeSearchDropdown(event) {
        this.element.nativeElement.querySelector('#swapa-qna-search-dropdown').setAttribute('class', 'flex-direction-column d-md-none d-none py-2');
        this.element.nativeElement.querySelector('#swapa-qna-search-button').setAttribute('class', 'btn btn-link btn-sm d-md-none swapa-search bg-white rounded-0');
        this.searchText = '';
    }

}
